<template>
  <main-content>
    <div class="col-12 col-md-4">
      <div class="card">
        <div class="card-header border-0"></div>
        <div class="card-body">
          <div class="d-flex flex-column align-items-center">
            <h1 style="font-size:3.5rem">{{$store.state.dashboard.listeners.length}}</h1>
            <h6>Listeners</h6>

            <div v-if="processing" style="position: relative;">
              <img :src="Icon" width="300" height="auto" />
            </div>

            <div v-if=" countries.data.length > 0" style="position: relative;">
              <component
                :is="'live-chart'"
                :height="200"
                style="height: auto;"
                :chartdata="this.countries.data"
                :chartlabels="this.countries.labels"
                :key="key"
              />
            </div>

            <!-- <ListenerCountChart
                 :height="200" 
                       :chartdata="this.countries.data"
            :chartlabels="this.countries.labels"/>-->
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-8 h-100">
      <div id="map"></div>
    </div>
  </main-content>
</template>


<script type="text/ecmascript-6">
import ListenerCountChart from "./components/DoughnutChart.vue";
import { Loader } from "@googlemaps/js-api-loader";
import _ from "lodash";
import Icon from "@/assets/Icon.svg";

export default {
  components: {
    "live-chart": ListenerCountChart,
  },

  watch: {
    listener_info: {
      immediate: true,
      handler(data) {
        this.countries = this.transformData(data, "country");
        this.key++;

        this.initMap();

        this.locations = data;
      },
    },
  },

  methods: {
    transformData(info, name) {
      let labels = [];
      let data = [];

      Object.entries(_.countBy(info, name)).forEach((item, index) => {
        labels[index] = `${item[0]} ${item[1]}`;
        data[index] = item[1];
      });

      return {
        labels: labels,
        data: data,
      };
    },

    initMap() {
      const loader = new Loader({
        apiKey: "AIzaSyADlY8zrt3CDSQEqahfIvnBakOPVW8l-4c",
        version: "weekly",
      });
      loader.load().then(() => {
        const map = new google.maps.Map(document.getElementById("map"), {
          zoom: 2,
          center: {
            lat: 5.614818,
            lng: -0.205874,
          },
        });
        this.locations.map((location, i) => {
          var infoWindow = new google.maps.InfoWindow({
            content: "Accra newtown",
          });

          const marker = new google.maps.Marker({
            position: location,
            // label: location.country,
            detail: `<strong style="color:#6f42c1;"><strong>${this.countries.labels.find(
              (item) => item.startsWith(location.country)
            )} </strong> listener(s)</strong>`,
            map: map,
          });

          google.maps.event.addListener(marker, "mouseover", function (mm) {
            infoWindow.setContent(marker.detail);
            infoWindow.open(map, marker);
          });

          google.maps.event.addListener(marker, "mouseout", function () {
            infoWindow.close();
          });
        });
      });
    },
  },

  data() {
    return {
      key: 0,
      locations: [],
      countries: {
        labels: [],
        data: [],
      },
      Icon,
    };
  },
};
</script>

<style scoped>
.table th,
.table td {
  border-top-style: none;
  padding: 0;
}

.card-footer {
  background-color: white !important;
}

#map {
  height: 400px;
}
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>

